import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 1em;

  .Etapa_div_addPrioridades {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 10em;
    height: 3em;
  }
`;

export const SelectColor = styled.div`
  display: flex;
  min-width: 7.04em;
  height: 2.5em;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 0.5em;
  margin-right: 0.5em;
  cursor: pointer;

  .color {
    ${(props) => props?.color ? `background: #${props?.color};` : `background: #8F9DAF;`}
    height: 100%;
    min-width: 4.54em;
    border-radius: 0.5em 0 0 0.5em;
  }

  .button {
    background: ${Colors?.Color23};
    height: 100%;
    width: 100%;
    border-radius: 0 0.5em 0.5em 0;
  }
`;

export const ModalColor = styled.div`
  padding: 1em 0 0 1em;
  background: ${Colors?.Color23};
  border-radius: 1em;
  box-shadow: 0px 0px 19px 0px rgb(4 4 4 / 25%) !important;
  height: fit-content;
  
  position: absolute;
  top: -10.5em;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 16em;
  left: 4em;
`;

export const ItemColor = styled.div`
  ${(props) => props?.color ? `background: #${props?.color};` : `background: #8F9DAF;`}
  min-height: 2em;
  min-width: 2em;
  border-radius: 0.5em;
  margin-bottom: 1em;
  margin-right: 1em;
  cursor: pointer;
`;
